import React, {useEffect, useState} from "react";
import {Select} from "grommet";
import { getSortFuncOnObjKey } from "../utils/sort";

const StateInput = ({
    value, country="US", stateOptions, onChange, ...rest
}) => {
    const [options, setOptions] = useState(stateOptions);
    useEffect(() => {
        setOptions(stateOptions);
    }, [stateOptions]);

    return (
        <Select
            placeholder={`Select ${country === "US" ? "state" : "region"}`}
            value={value}
            labelKey="name"
            valueKey={{ key: 'value', reduce: true }}
            options={options}
            onChange={(event) => onChange && onChange(event)}
            onClose={() => setOptions(stateOptions)}
            onSearch={text => {
                const escapedText = text.toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
                const exp = new RegExp(escapedText, 'i');
                const filteredOptions = stateOptions.filter(option => exp.test(option.name.toLowerCase()));
                const sortedOptions = filteredOptions.sort(getSortFuncOnObjKey("name"));
                setOptions(sortedOptions);
            }}
            {...rest}
        />
    );
};

export default StateInput;
